(function () {
    'use strict';

    angular
        .module('edufindme')
        .controller('AdminEdufindmeController', AdminEdufindmeController);

    AdminEdufindmeController.$inject = [
                '$uibModalInstance',
                'client',
                'type',
                'PlanService',
                'AdminEdufindmeService',
                'ProfileTypeService',
                'CountriesNewService',
                'AgentBranchesService',
                'toastr',
                '$timeout'
    ];

    function AdminEdufindmeController(
            $uibModalInstance,
            client,
            type,
            PlanService,
            AdminEdufindmeService,
            ProfileTypeService,
            CountriesNewService,
            AgentBranchesService,
            toastr,
            $timeout)
    {
        var vm = this;

        vm.required                             = true;
        vm.AdministratorId                      = 0;
        vm.errorMessage                         = false;
        vm.isEdition                            = false;
        vm.administrators                       = [];
        vm.query                                = {};
        vm.adminBranches                        = [];
        vm.adminBranchesSelected                = [];
        vm.user_id                              = [];
        vm.client                               = client;
        vm.type                                 = type;
        vm.adminName                            = '';
        vm.adminPassword                        = [];
        vm.adminConfirmPassword                 = [];
        vm.adminEmail                           = '';
        vm.adminProfileType                     = [];
        vm.adminProfileTypeSelected             = [];
        vm.adminCountry                         = [];
        vm.adminManageAgent                     = false;
        vm.adminWhichStudentSelected            = [];
        vm.adminDisplayContact                  = [];
        vm.adminType                            = [];
        vm.ok                                   = ok;
        vm.cancel                               = cancel;
        vm.save                                 = save;
        vm.selectCountry                        = selectCountry;
        vm.selectProfileType                    = selectProfileType;
        vm.selectBranches                       = selectBranches;
        vm.listAdministrators                   = listAdministrators;
        vm.edit                                 = edit;
        vm.cleanForm                            = cleanForm;
        vm.selectedAllInStudentCountry          = selectedAllInStudentCountry;
        vm.selectCountryAdmin                   = selectCountryAdmin;
        vm.deleteAdmin                          = deleteAdmin;

        vm.Config = {
            plugins: ['remove_button'],
            create: false,
            valueField: 'id',
            labelField: 'name',
            delimiter: '|',
            placeholder: 'Select a country...',
            searchField: ['name'],
            onItemAdd: vm.selectedAllInStudentCountry,
            render: {
                item: function (item, escape) {
                    return '<span class="ui-select-match">'+
                        (item.name ? '<span class="name ui-select-match-item btn btn-default btn-xs">' + escape(item.name) + '</span>' : '') +
                        '</span>';

                }
            }
        };

        activate();

        function activate() {
            vm.selectCountry();
            vm.selectProfileType();
            if(vm.type == 'agents')
                vm.selectBranches(vm.client.user_id);
            vm.listAdministrators();
        }

        function cleanForm() {
            if(vm.type == 'institutions') {
                vm.adminManageAgent          = [];
                vm.adminDisplayContact       = [];
            } else {
                vm.adminManageAgent          = [];
                vm.adminBranchesSelected     = [];
            }

            vm.adminName                    = [];
            vm.adminEmail                   = [];
            vm.adminPassword                = undefined;
            vm.adminConfirmPassword         = [];
            vm.AdministratorId              =  0;
            vm.adminProfileTypeSelected     = [];
            vm.adminWhichStudentSelected    = [];
            vm.isEdition                    = false;
        }

        function listAdministrators () {
            vm.query['id']   = vm.client.user_id ? vm.client.user_id : vm.client.users_id;
            vm.query['type'] = vm.type;
            AdminEdufindmeService.administrators(vm.query).then(function(response){
                vm.administrators   = response.data;
            }).catch(function(err) {

            });
        }

        function selectBranches(user,edit) {
            var cod=[];
            if(typeof edit =='undefined')
                cod['user_id'] = user;
            else
                cod = user;

            AgentBranchesService.getBranches(cod).then(function(response){
                if(typeof edit == 'undefined') {
                    vm.adminBranches           = response.data;
                } else {
                    vm.adminBranchesSelected   = response.data;
                }

            }).catch(function(err) {

            });
        }

        function selectProfileType(user) {
            var cod = [];
            if(typeof user =='undefined'){
                cod['type'] = vm.type;
                cod['cod_profile_manager'] = client.id;
            } else {
                cod = user;
            }

            ProfileTypeService.getProfilesType(cod).then(function(response){
                if(typeof user == 'undefined') {
                    vm.adminProfileType          = response.data;
                } else {
                    vm.adminProfileTypeSelected  = response.data;
                }

            }).catch(function(err) {

            });
        }

        /* DYNAMIC SELECT OF INSTITUTION */
        function selectCountry (user) {
            var cod;
            if(typeof user =='undefined'){
                cod = null;
            } else {
                cod = user;
            }

            CountriesNewService.getCountries(cod).then(function(response){
                    if (typeof user == 'undefined') {

                            vm.adminCountry = response.data;
                            vm.adminCountry.unshift({id: 'all', name: 'All'});
                        return;
                    }
                $timeout(function () {
                    vm.adminWhichStudentSelected = response.data;
                    return;
                },0);

            }).catch(function(err) {
                console.log(err);
            });
        }

        /* DYNAMIC SELECT OF INSTITUTION - MODAL ADMIN*/
        function selectCountryAdmin (user) {
            var cod;
            if(typeof user =='undefined'){
                cod = null;
            } else {
                cod = user;
            }

            CountriesNewService.getCountriesAdmin(cod).then(function(response){
                if (typeof user == 'undefined') {

                    vm.adminCountry = response.data;
                    vm.adminCountry.unshift({id: 'all', name: 'All'});
                    return;
                }
                $timeout(function () {
                    vm.adminWhichStudentSelected = response.data;
                    return;
                },0);

            }).catch(function(err) {
                console.log(err);
            });
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function save() {
            vm.query;
            console.log(vm.client);
            if(vm.type == 'institutions') {
                vm.query['institution_id']      = vm.client.user_id;
                vm.query['branches']            = vm.adminBranchesSelected;
                vm.query['agents']              = vm.adminManageAgent;
                vm.query['display_contact']     = vm.adminDisplayContact;
            }
            if(vm.type == 'agents') {
                vm.query['agent_id']            = vm.client.user_id;
                vm.query['branches']            = vm.adminBranchesSelected;
                vm.query['agents']              = vm.adminManageAgent;
                vm.query['display_contact']     = vm.adminDisplayContact;
            }
            if(vm.type == 'governments') {
                vm.query['government_id']       = vm.client.users_id;
                vm.query['branches']            = vm.adminBranchesSelected;
                // vm.query['governments']         = vm.adminManageAgent;
                vm.query['schools']             = vm.adminManageAgent;
                // vm.query['display_contact']      = vm.adminDisplayContact;
            }
            if(vm.type == 'others') {
                vm.query['other_id']            = vm.client.users_id;
                vm.query['branches']            = vm.adminBranchesSelected;
                vm.query['schools']             = vm.adminManageAgent;
            }

            vm.query['typeSearch']       = vm.type;
            vm.query['name']             = vm.adminName;
            vm.query['email']            = vm.adminEmail;
            vm.query['password']         = vm.adminPassword;
            vm.query['profile_types']    = vm.adminProfileTypeSelected;
            vm.query['which_students']   = vm.adminWhichStudentSelected;
            vm.query['isEdition']        = vm.isEdition;

            if(vm.isEdition == true) {
                vm.query['user_id']      = vm.user_id;
            }

            console.log("Edit data", vm.query);
            AdminEdufindmeService.saveAdmin(vm.query).then( function(response){
                if(vm.isEdition == true)
                    toastr.success('Successfully edited!');
                else
                    toastr.success('Successfully saved!');
                vm.cleanForm();
                vm.listAdministrators();
                vm.isEdition = false;
                vm.required  = true;
            });

        }

        // function selectedAllInStudentCountry() {
        //     //for(var i=0; i < vm.adminWhichStudentSelected.length; i++) {
        //     vm.adminWhichStudentSelected.map(function(value){
        //
        //     });
        //
        //     //}
        // }

        function selectedAllInStudentCountry(value) {

            // caso 1: Primeiro item selecionado é o All
            if(value == 'all' && vm.adminWhichStudentSelected.length == 0) {
                return; // não faz nada.
            }

            // caso 2: Algum item selecionado e seleciona o all
            if(value == 'all' && vm.adminWhichStudentSelected.length > 0) {
                $timeout(function () {
                    vm.adminWhichStudentSelected = []; // zera o model (evita duplicatas na chamada, cai no caso base)
                    vm.adminWhichStudentSelected = ['all']; // seleciona apenas o all;
                }, 0);
                return;
            }

            // caso 3: All selecionado e seleciona algum item
            if(vm.adminWhichStudentSelected.length == 1 && vm.adminWhichStudentSelected[0] == 'all') {
                $timeout(function () {
                    vm.adminWhichStudentSelected = []; // zera o model (evita duplicatas na chamada, cai no caso base)
                    vm.adminWhichStudentSelected = [value]; // seleciona apenas o item;
                }, 0);
                return;
            }
        }

        function edit(client) {
            console.log(client);
            vm.required  = false;
            var requestBranch = [];
            var profile = [];
            if(vm.type == 'institutions') {
                vm.user_id                   = client.users_id;
                vm.adminManageAgent          = client.agents==1?true:false;
                vm.adminDisplayContact       = client.display_contact == 1?true:false;
            }
            if(vm.type == 'agents') {
                vm.user_id                   = client.users_id;
                vm.adminName                 = client.adminName;
                vm.adminManageAgent          = client.schools=='1'?true:false;
                requestBranch['user_id']     = vm.client.user_id;
                requestBranch['branches']    = client.branches;
                vm.selectBranches(requestBranch, true);
            }
            if(vm.type == 'governments') {
                vm.user_id                   = client.users_id;
            }
            if(vm.type == 'others') {
                vm.user_id                   = client.users_id;
            }

            vm.adminName                    = client.name;
            vm.adminEmail                   = client.email;
            vm.AdministratorId              = client.users_id;

            // console.log(vm.AdministratorId);
            profile['id']   = client.users_id;
            profile['type'] = vm.type;
            vm.selectProfileType(profile);
            //if(client.citizenships == '' || typeof client.citizenships == 'undefined'){
                vm.selectCountryAdmin(client.citizenships);
            //}
            vm.isEdition = true;
        }

        function deleteAdmin(user) {
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancel'
                })
                .set('title', 'Do you really want to delete this administrator?')
                .set('onok', function (){
                    AdminEdufindmeService.deleteAdmin(vm.type, user.id).then( function(response){
                        vm.administrators.splice(vm.administrators.indexOf(user), 1);
                        toastr.success('User administrator successfull deleted!');
                    });
                })
                .show();
        }

    }

})();